import React from 'react'
import styled from 'styled-components'

import { mediaMax } from 'styles/media'

type Options = {
  gutter?: number
  centered?: boolean
  firstGutter?: number
}

const Inner = styled.div<Options>`
  display: flex;
  margin: 0 auto;

  ${({ centered, firstGutter }) =>
    centered === false &&
    `
    margin: 0 ${firstGutter || 0}px;
 `}

  ${mediaMax.xl`
    padding: 0 ${({ gutter }: Options) => gutter}px;
  `}

  & > * {
    margin-right: ${({ gutter }) => gutter}px;

    &:last-child {
      margin-right: 0;
    }
  }
`

const Outer = styled.div`
  display: flex;

  ${mediaMax.xl`
    overflow-x: scroll;
    padding-bottom: 16px; /* accommodate horizontal scrollbar */
  `}
`

type HorizontallyScrollableProps = Options

const HorizontallyScrollable: React.FC<HorizontallyScrollableProps> = ({
  gutter = 30,
  centered = true,
  firstGutter,
  children,
}) => {
  return (
    <Outer>
      <Inner gutter={gutter} centered={centered} firstGutter={firstGutter}>
        {children}
      </Inner>
    </Outer>
  )
}

export default HorizontallyScrollable
